import * as components from './components';

export default [
    {
        path: '/',
        component: components.MainView
    }
];



// WEBPACK FOOTER //
// ./src/app/Main/routes.js